module.exports = __webpack_public_path__ + "assets/img/10.fb33e588.png";